module.exports = __webpack_public_path__ + "static/grick-brandname-903ab23708571bb8f8bf1accb0024b30.png";